export default "__VITE_ASSET__DFdcBaWR__"